import { Dropdown, Icon, MessageBar, MessageBarType, Stack, TooltipHost } from "@fluentui/react"
import { ProgressIndicator } from "@fluentui/react/lib/ProgressIndicator"
import { useState } from "react"
import { useApiCall, useRoles } from "../hooks/apiHooks"
import { IReportParameters, ParametersProvider } from "../providers/parametersProvider"
import { Report } from "./report"

interface ReportsProps {
	controlType: "WebResource" | "Portal"
}

interface IReportAdvancedConfiguration {
	Parameters: IReportParameters
}

export interface IReportConfiguration {
	cw_name: string
	cw_reportconfigurationid: string
	cw_description: string
	cw_configuration: IReportAdvancedConfiguration
}

export function Reports({ controlType }: ReportsProps) {
	const [selectedReportConfiguration, setSelectedReportConfiguration] = useState<IReportConfiguration>()
	const { roles } = useRoles()
	const { data: reportConfigurations = [], loading, error } = useApiCall<any[]>("getReportConfigurations", { method: "POST", body: JSON.stringify({ roles }), canFetch: !!roles })
	const reportConfigurationOptions = (reportConfigurations || []).map(rc => ({ text: rc.cw_name, key: rc.cw_reportconfigurationid }))

	return (
		<>
			<Stack tokens={{ childrenGap: 10 }} style={{ padding: 15 }}>
				{error && <MessageBar messageBarType={MessageBarType.error}>There was an error loading reports</MessageBar>}
				{loading && <ProgressIndicator />}
				{!loading && reportConfigurations && reportConfigurations.length > 0 && (
					<Stack tokens={{ childrenGap: 10 }}>
						<Dropdown
							options={reportConfigurationOptions}
							onRenderOption={option => {
								const configuration = reportConfigurations.find(rc => rc.cw_reportconfigurationid === option.key)
								return (
									<Stack horizontal tokens={{ childrenGap: 8 }}>
										<TooltipHost content={<div dangerouslySetInnerHTML={{ __html: configuration.cw_description }} />}>
											<Icon iconName="Info" />
										</TooltipHost>
										<span>{option.text}</span>
									</Stack>
								)
							}}
							selectedKey={selectedReportConfiguration?.cw_reportconfigurationid}
							label="Report"
							placeholder="Select a report..."
							onChange={(_ev, option) => {
								const configuration = reportConfigurations.find(rc => rc.cw_reportconfigurationid === option.key)
								setSelectedReportConfiguration(configuration)
							}}
						/>
					</Stack>
				)}
				{selectedReportConfiguration && (
					<ParametersProvider parameters={selectedReportConfiguration.cw_configuration.Parameters}>
						<Report reportConfiguration={selectedReportConfiguration} />
					</ParametersProvider>
				)}
			</Stack>
		</>
	)
}
